import classes from "./Filters.module.css";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { toast } from "react-toastify";
import Loader from "../../UI/Loader";
import { FaPlay, FaEraser } from 'react-icons/fa';

const Filters = (props) => {
  const { t } = useTranslation();
  // 👉 Utility function to get today's date in YYYY-MM-DD format
  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  const [startDate, setStartDate] = useState(getTodayDate()); // default today
  const [endDate, setEndDate] = useState(getTodayDate()); // default today
  const [dateError, setDateError] = useState({ startDate: "", endDate: "" });
  const [loading, setLoading] = useState(false);

  // Validate both start and end date
  const validateDate = (start, end) => {
    let startError = "";
    let endError = "";

    if (!start) startError = t("Please select a start date");
    if (!end) endError = t("Please select an end date");

    if (start && end) {
      const diffDays =
        (new Date(end) - new Date(start)) / (1000 * 60 * 60 * 24);
      if (diffDays < 0) endError = t("End date cannot be before start date");
      if (diffDays > 90)
        endError = t("Date range cannot exceed 90 days from start date");
    }

    return { startDate: startError, endDate: endError };
  };

  const onGetStartDateHandler = (e) => {
    const dateValue = e.target.value;
    setStartDate(dateValue);

    const errors = validateDate(dateValue, endDate);
    setDateError(errors);
  };

  const onGetEndDateHandler = (e) => {
    const dateValue = e.target.value;
    setEndDate(dateValue);

    const errors = validateDate(startDate, dateValue);
    setDateError(errors);

    if (errors.endDate) {
      toast.error(errors.endDate);
    }
  };

  const onGetStartAndEndDate = (e) => {
    e.preventDefault();

    const errors = validateDate(startDate, endDate);
    setDateError(errors);

    if (errors.startDate || errors.endDate) {
      if (errors.startDate) toast.error(errors.startDate);
      if (errors.endDate) toast.error(errors.endDate);
      return;
    }

    props.onGetStartAndEndDate(startDate, endDate); // 🔥 Only called on submit
  };

  const onClearFields = () => {
    setStartDate(getTodayDate());
    setEndDate(getTodayDate());
    setDateError({ startDate: "", endDate: "" });
  };

  return (
    <div className="container filterReports bg-light p-3 rounded shadow-sm border mb-4">
      {loading && <Loader />}
      <form onSubmit={onGetStartAndEndDate}>
        <div className="d-flex flex-wrap align-items-end gap-3 justify-content-center">
          <div className="flex-grow-1" style={{ minWidth: "150px" }}>
            <label className="fw-bold small mb-1" htmlFor="startDate">
              {t("Start Date")}
            </label>
            <input
              id="startDate"
              type="date"
              className={`form-control ${dateError.startDate ? classes.invalid : ""}`}
              value={startDate}
              onChange={onGetStartDateHandler}
              style={{ border: "1px solid #ced4da" }}
            />
          </div>

          <div className="flex-grow-1" style={{ minWidth: "150px" }}>
            <label className="fw-bold small mb-1" htmlFor="endDate">
              {t("End Date")}
            </label>
            <input
              id="endDate"
              type="date"
              key={endDate}
              className={`form-control ${dateError.endDate ? classes.invalid : ""}`}
              value={endDate}
              onChange={onGetEndDateHandler}
              min={startDate || ""}
              style={{ border: "1px solid #ced4da" }}
            />
          </div>

          <div className="d-flex gap-2 mbcell">
            <button
              type="submit"
              className="btn-premium"
              disabled={dateError.startDate || dateError.endDate}
            >
              <FaPlay className="me-2" /> {t("SUBMIT")}
            </button>
            <button
              type="button"
              className="btn-secondary-premium"
              onClick={onClearFields}
            >
              <FaEraser className="me-2" /> {t("CLEAR")}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Filters;
